import { getService, postService } from "../../axios/services";

export const searchCultureHubProjects = ({ title, pageIndex, pageSize, cancelToken }) =>
  getService({
    endpoint: "CultureHub/projects",
    api: "v2",
    params: { Title: title, PageIndex: pageIndex, PageSize: pageSize },
    options: { cancelToken },
  });

export const createAssessment = ({
  fileId,
  assessmentTypeId,
  attachmentIds,
  cancelToken,
}) =>
  postService({
    endpoint: "Assessments",
    api: "v2",
    postData: { fileId, assessmentTypeId, attachmentIds },
    options: { cancelToken },
  });
